import { Controller } from "@hotwired/stimulus"

// Previews a selected image file in an <img> element before upload.
export default class extends Controller {
  static targets = ["thumbnail"]

  connect() {
    this.objectUrl = null
  }

  disconnect() {
    this.releaseUrl()
  }

  show(event) {
    const [file] = event.target.files
    this.releaseUrl()

    if (!file) {
      this.clearThumbnail()
      return
    }

    this.objectUrl = URL.createObjectURL(file)
    this.thumbnailTarget.src = this.objectUrl
    this.thumbnailTarget.hidden = false
  }

  clearThumbnail() {
    this.thumbnailTarget.removeAttribute("src")
    this.thumbnailTarget.hidden = true
  }

  // Free browser memory when replacing or removing the preview image.
  releaseUrl() {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
